export const aiPhotoGenerationFolderName = 'Библиотека\u00A0генераций';

export const aiPhotoGenerationFolderId = `/${aiPhotoGenerationFolderName}`;

export const aiPhotoGenerationFolderPathFromRoot = `/home/${aiPhotoGenerationFolderName}`;
